module.exports = __webpack_public_path__ + "images/application/templates/comment-notification-6b599a2e.png";